import { i18n } from '@lingui/core'
import {
  en as pluralEn,
  de as pluralDe,
  it as pluralIt,
  fr as pluralFr,
  nl as pluralNl,
} from 'make-plural/plurals'
import { messages as messagesEn } from './en/messages'
import { messages as messagesDeDE } from './de-DE/messages'
import { messages as messagesDeAT } from './de-AT/messages'
import { messages as messagesItIT } from './it-IT/messages'
import { messages as messagesBeFR } from './fr-BE/messages'
import { messages as messagesBeNL } from './nl-BE/messages'

export const enum LanguageCodes {
  EN = 'en',
  DE_DE = 'de-DE',
  DE_AT = 'de-AT',
  FR_BE = 'fr-BE',
  NL_BE = 'nl-BE',
  IT_IT = 'it-IT',
}

i18n.load({
  [LanguageCodes.EN]: messagesEn,
  [LanguageCodes.DE_DE]: messagesDeDE,
  [LanguageCodes.DE_AT]: messagesDeAT,
  [LanguageCodes.IT_IT]: messagesItIT,
  [LanguageCodes.FR_BE]: messagesBeFR,
  [LanguageCodes.NL_BE]: messagesBeNL,
})
i18n.loadLocaleData(LanguageCodes.EN, { plurals: pluralEn })
i18n.loadLocaleData(LanguageCodes.DE_DE, { plurals: pluralDe })
i18n.loadLocaleData(LanguageCodes.DE_AT, { plurals: pluralDe })
i18n.loadLocaleData(LanguageCodes.IT_IT, { plurals: pluralIt })
i18n.loadLocaleData(LanguageCodes.FR_BE, { plurals: pluralFr })
i18n.loadLocaleData(LanguageCodes.NL_BE, { plurals: pluralNl })

export default i18n
